<table mat-table [dataSource]="dataSource" class="mat-elevation-z0 table-border" matSort
  (matSortChange)="sortChange($event)" aria-label="Table">
  <ng-container matColumnDef="channelIcon">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="width-80" >
      <span> Channel </span>
    </th>
    <td mat-cell *matCellDef="let data" class="additional-table">
      <button mat-icon-button [style.visibility]="!data.expandable ? 'hidden' : ''"
        [style.display]="!data.expandable ? data.level === 0 ? 'none' : '' :''" [style.paddingLeft.px]="data.level * 21"
        (click)="treeControl.toggle(data);data['isExpanded'] = !data['isExpanded']">
        <span *ngIf="data['isExpanded']">
          <f-icon icon-config='{"iconName": "chevron-down", "iconType": "light", "iconSize": "s"}'></f-icon>
        </span>
        <span *ngIf="!data['isExpanded']">
          <f-icon icon-config='{"iconName": "chevron-right", "iconType": "light", "iconSize": "s"}'></f-icon>
        </span>
      </button>
      <!-- CCR3-13170  Icon for Multi Account-->
      <span class="multiple-account" *ngIf="data?.multipleAccountData && data?.multipleAccountData.length > 0">
        <f-icon icon-config='{"iconName": "users", "iconType": "solid", "iconSize": "s"}'></f-icon>
      </span>
      <span class="additional-account" *ngIf="data?.additionalAccountsData && data?.additionalAccountsData.length > 0 && (!data?.multipleAccountData)">
         <f-icon icon-config='{"iconName": "user-plus", "iconType": "solid", "iconSize": "s"}'></f-icon>
      </span>     
      <f-icon [title]="data['title']" class="{{data['channelIcon']}}" [iconConfig]="{iconName: data['channelIcon'], iconType: 'light', iconSize: 's'}"></f-icon>
  
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell mat-sort-header *matHeaderCellDef   class="width-120"> Date </th>
    <td mat-cell [title]="data['date']" *matCellDef="let data" class="truncate"> {{data.date}} </td>
  </ng-container>

  <ng-container matColumnDef="startTime">
    <th mat-header-cell *matHeaderCellDef class="width-120"> Start/Rcvd Time </th>
    <td mat-cell [title]="data['startTime']" *matCellDef="let data" class="truncate"> {{data.startTime}} </td>
  </ng-container>

  <ng-container matColumnDef="topic">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="width-270"> Topic/Title/Subject </th>
    <td mat-cell [title]="data['topic']" *matCellDef="let data" class="truncate" [ngClass]="{ red: displayRed(data)}">
      <f-icon *ngIf="displayRed(data)" icon-config='{"iconName": "circle-exclamation", "iconType": "solid", "iconSize": "s"}'></f-icon>
      {{data.topic}}
    </td>
  </ng-container>

  <ng-container matColumnDef="agent">
    <th mat-header-cell mat-sort-header *matHeaderCellDef  class="width-130"> Agent </th>
    <td mat-cell [title]="data['agent']" *matCellDef="let data" class="truncate"> {{data.agent}} </td>
  </ng-container>

  <ng-container matColumnDef="conversationId">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="width-100"> Conversation ID </th>
    <td mat-cell [title]="data['conversationId']" *matCellDef="let data" class="truncate"> {{data.conversationId}} </td>
  </ng-container>

  <ng-container matColumnDef="mood">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="width-50"> Mood </th>
    <td mat-cell [title]="data['mood']" *matCellDef="let data" class="truncate">
      <span *ngIf="data['mood'] === 'Kudos'"> <f-icon class="green" icon-config='{"iconName": "thumbs-up", "iconType": "solid", "iconSize": "s"}' title="kudos"></f-icon> </span>
      <span *ngIf="data['mood'] === 'Dissatisfied'"><f-icon class="red" icon-config='{"iconName": "thumbs-down", "iconType": "solid", "iconSize": "s"}' title="Dissatisfied"></f-icon>
      </span>
    </td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length" *ngIf="noRecord()">
      <div class="center no-result">
        <p>{{noRecordFoundMsg}}</p>
      </div>

    </td>
  </tr>
  <!-- CCR1-3138 -->
  <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowSingleClick(row)"
    (keydown.enter)="onTableRowEnter(row)" (focus)="selectedRow = row" [ngClass]="{ selected: isRowSelected(row) }"
    tabindex="0">
  </tr>
</table>
<div class="footer-controls">
  <div class="footer-controls-left"></div>
  <div class="footer-controls-right" *ngIf="displayPagination()">

    <div class="custom-pagination ">
      <button class="arrow-btn" mat-stroked-button title="Start Page" disabled="{{ pager.currentPage === 1 }}"
        (click)="setPage(1)">
        <f-icon icon-config='{"iconName": "chevrons-left", "iconType": "light", "iconSize": "s"}'></f-icon>
      </button>

      <button class="arrow-btn" mat-stroked-button title="Previous" disabled="{{ pager.currentPage === 1 }}"
        (click)="setPage(pager.currentPage - 1)">
        <f-icon icon-config='{"iconName": "chevron-left", "iconType": "light", "iconSize": "s"}'></f-icon>
        </button>
      <span *ngFor="let num of pager.pages;">
        <button class="number" title="{{num}}" [ngClass]="pager.currentPage   === num ? 'selected' :'' "
          (click)="setPage(num)" mat-stroked-button>{{num}}</button>
      </span>



      <button class="arrow-btn" mat-stroked-button title="Next" disabled="{{ pager.currentPage === pager.totalPages }}" 
      (click)="setPage(pager.currentPage + 1)">
        <f-icon icon-config='{"iconName": "chevron-right", "iconType": "light", "iconSize": "s"}'></f-icon>
      </button>

      <button class="arrow-btn" mat-stroked-button title="Last Page"
        disabled="{{ pager.currentPage === pager.totalPages }}" (click)="setPage(pager.totalPages)">
        <f-icon icon-config='{"iconName": "chevrons-right", "iconType": "light", "iconSize": "s"}'></f-icon>
      </button>
    </div>
  </div>
</div>